<template>
  <a href="#" class="back-to-top js-back-to-top">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.0607 0.939341C12.4749 0.353554 11.5251 0.353554 10.9393 0.939341L1.3934 10.4853C0.807611 11.0711 0.807611 12.0208 1.3934 12.6066C1.97919 13.1924 2.92893 13.1924 3.51472 12.6066L12 4.12132L20.4853 12.6066C21.0711 13.1924 22.0208 13.1924 22.6066 12.6066C23.1924 12.0208 23.1924 11.0711 22.6066 10.4853L13.0607 0.939341ZM13.5 24L13.5 2H10.5L10.5 24H13.5Z" fill="white"/>
    </svg>
  </a>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  mounted() {
    $(window).on("scroll", function(e) {
      if ($(this).scrollTop() > 0) {
          $('.js-back-to-top').css("display", "flex").fadeIn();
      } else {
          $('.js-back-to-top').fadeOut('slow');
      }
    });

    $(".js-back-to-top").on("click", function(e) {
      $("html, body").animate({
          scrollTop: 0
      }, 100);
      return false;
    });
      },
    }
</script>

<style scoped>
/* back-to-top */
.back-to-top {
  position: fixed;
  bottom: 120px;
  /* top: 0; */
  /* margin: auto; */
  right: 20px;
  right: 1.25rem;
  z-index: 99;
  display: none;
  text-align: center;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  justify-content: center;
  align-items: center;
  background-repeat: no-repeat;
  background-color: var(--main-color);
  background-position: center;
  -webkit-transition: background-color 0.1s linear;
  transition: background-color 0.1s linear;
  line-height: 1.875rem;
  box-shadow: rgb(38, 57, 77) 0px 20px 30px -21px;
}

.back-to-top:hover, .back-to-top:focus {
  color: #fff;
}

.back-to-top i {
  padding-top: 0;
  font-size: 14px;
  font-size: 0.875rem;
  color: #fff;
}

.top_arr {
  position: relative;
  width: 100%;
  height: 100%;
}

.top_arr::after {
  content: "";
  position: absolute;
  left: 7px;
  top: 14px;
  width: 10px;
  height: 2px;
  transform: rotate(-51deg);
  background-color: #eeeeee;
}

.top_arr::before {
  content: "";
  position: absolute;
  left: 13px;
  top: 14px;
  width: 10px;
  height: 2px;
  transform: rotate(51deg);
  background-color: #eeeeee;
}

@media (max-width: 500px) {
  .back-to-top {
    width: 50px;
    height: 50px;
    bottom: 95px;
  }
}
/* back-to-top end */
</style>